import { ComputerDesktopIcon, MoonIcon, SunIcon } from "@heroicons/react/20/solid";

export const THEMES = { light: "light", dark: "dark", system: "system" } as const;

export type Theme = (typeof THEMES)[keyof typeof THEMES];

export const THEME_OPTIONS = [
    { value: THEMES.light, label: "Светлая", icon: SunIcon },
    { value: THEMES.dark, label: "Тёмная", icon: MoonIcon },
    { value: THEMES.system, label: "Как в системе", icon: ComputerDesktopIcon },
] as const;

export function isTheme(value: string | undefined): value is Theme {
    return value === THEMES.light || value === THEMES.dark || value === THEMES.system;
}
